import { render, staticRenderFns } from "./FluSummary.vue?vue&type=template&id=1bf45994&scoped=true&"
import script from "./FluSummary.vue?vue&type=script&lang=js&"
export * from "./FluSummary.vue?vue&type=script&lang=js&"
import style0 from "./FluSummary.vue?vue&type=style&index=0&id=1bf45994&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf45994",
  null
  
)

export default component.exports